import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  updateMeetingDetails,
  updateStep,
} from "../../redux/actions/meetingActions/MeetingAction";

import "../Login/style/Login.css";
import LoaderButton from "../Common/LoaderButton";
import { logOut } from "../../redux/actions/authActions/authAction";
import { encryptWithAES } from "../../helpers/commonHelpers";
import AddAgendaModal from "./AddAgendaModal";
import SmallLoaderButton from "../Common/SmallLoaderButton";
const AddAgendas = ({ showRemoveButton }) => {
  const accessToken = localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const dispatch = useDispatch();
  const meetingData = useSelector((state) => state.meeting);

  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const [numAgenda, setNumAgenda] = useState(1);
  const location = useLocation();
  const stateData = location.state;
  const [errors, setErrors] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAgendaId, setSelectedAgendaId] = useState(null);
  const [agendaData, setAgendaData] = useState([]);
  const [isAddAgendaModal, setIsAddAgendaModal] = useState(false);

  useEffect(() => {
    document.title = "Create Meeting: MinutesVault";
    if (stateData.isMeetingDataUpdate || meetingData.isUpdateStep) {
      document.title = "Update Meeting: MinutesVault";
    }
    const meetingAgenda = meetingData?.singleMeetingDetails?.agendasDetail?.map(
      (item) => {
        item.uid = Math.floor(100000 + Math.random() * 900000);
        return item;
      }
    );
    setAgendaData(meetingAgenda);
  }, [meetingData?.singleMeetingDetails]);

  const goToTop = () => {
    window.scrollTo(0, 0);
  };

  const submitAgendasDetails = async (e) => {
    e.preventDefault();

    if (meetingData?.singleMeetingDetails?.attendees?.length >= 2) {
      const meetingId = meetingData?.singleMeetingDetails?._id;

      const payload = {
        sendNotification: true,
        organizationId: userData.organizationId,
        step: 3,

        meetingStatus:
          meetingData?.singleMeetingDetails?.meetingStatus?.status === "draft"
            ? "scheduled"
            : meetingData?.singleMeetingDetails?.meetingStatus?.status,

        isUpdate:
          stateData.isMeetingDataUpdate &&
            meetingData.singleMeetingDetails.step === 3
            ? true
            : false,
      };
      const fromUpdate =
        meetingData?.singleMeetingDetails?.step === 3 ? true : false;

      dispatch(
        updateMeetingDetails(
          meetingId,
          payload,
          accessToken,
          "addAgenda",
          stateData.isMeetingDataUpdate,
          false,
          fromUpdate
        )
      );
    } else {
      toast.warning("Please add minimum 2 attendees.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const onAddAgenda = (data) => {
    const uid = Math.floor(100000 + Math.random() * 900000);

    setAgendaData([
      ...agendaData,
      {
        // topic: data.topic,
        topic: encryptWithAES(data.topic),
        timeLine: data.timeLine,
        title: data.title,
        _id: data._id,
        uid,
      },
    ]);

    setNumAgenda(numAgenda + 1);
  };

  const onDeleteAgenda = (id) => {
    const modiFiedData = agendaData.filter((agenda) => agenda?._id !== id);

    setAgendaData(modiFiedData);
  };

  const onRemoveAgenda = (uid) => {
    const filteredAgenda = agendaData.filter((item) => item.uid !== uid);
    setAgendaData(filteredAgenda);
  };
  const handleDeleteConfirm = async () => {
    try {
      setIsLoading(true);
      if (selectedAgendaId) {
        onRemoveAgenda(selectedAgendaId);
      }
      setShowDeleteModal(false);
      setSelectedAgendaId(null);
    } catch (error) {
      console.error("Error while removing Agenda:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddAgendaModal = (status) => {
    setIsAddAgendaModal(status);
  };
  return (
    <>
      <form className="mt-2 no-padding-2" onSubmit={submitAgendasDetails}>
        {agendaData?.length === 0 ? (
          <div className="col-12">
            <div className="alert alert-warning padding-8">
              Note: Please add atleast 1 agenda to schedule the meeting.
            </div>
          </div>
        ) : null}
        {meetingData?.singleMeetingDetails?.isSendNotification === false &&
          meetingData?.singleMeetingDetails?.agendaIds?.length !== 0 &&
          meetingData?.singleMeetingDetails?.step === 2 ? (
          <div className="col-12">
            <div className="alert alert-warning">
              Note: Please save to schedule the meeting.
            </div>
          </div>
        ) : null}

        {meetingData?.singleMeetingDetails?.isSendNotification === false &&
          meetingData?.singleMeetingDetails?.step === 3 ? (
          <div className="col-12">
            <div className="alert alert-warning">
              Note: Please send notification to inform the updated meeting data.
            </div>
          </div>
        ) : null}

        <div className="inner-detail-form">
          <button
            type="button"
            className="btn  add-btn Mom-btn d-flex align-items-center justify-content-center filter-height"
            onClick={() => {
              handleAddAgendaModal(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="#fff"
              className="bi bi-plus-circle pointer me-2"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
            </svg>
            <p> Add Agenda </p>
          </button>

          <div>
            {errors.addAgenda ? (
              <span className="error-message">{errors.addAgenda}</span>
            ) : null}
            <div className="button-outer" style={{ marginTop: 20 }}>
              <button
                className="add-btn Mom-btn "
                onClick={(e) => dispatch(updateStep(1, true))}
              >
                <p>Back</p>
              </button>

              {meetingData?.singleMeetingDetails?.isSendNotification ===
                false &&
              meetingData?.singleMeetingDetails?.agendaIds?.length !== 0 &&
              meetingData?.singleMeetingDetails?.step === 2 &&
              agendaData?.length !== 0 ? (
                <>
                  {!meetingData.updateLoading ? (
                    <button
                      className="create-meeting-button Mom-btn"
                      type="submit"
                    >
                      <p>Save & Notify </p>
                    </button>
                  ) : (
                    <SmallLoaderButton />
                  )}
                </>
              ) : null}

              {meetingData?.singleMeetingDetails?.isSendNotification ===
                false && meetingData?.singleMeetingDetails?.step === 3 ? (
                <>
                  {!meetingData.updateLoading ? (
                    <button
                      className="create-meeting-button Mom-btn "
                      type="submit"
                    >
                      <p>Send Notification</p>
                    </button>
                  ) : (
                    <SmallLoaderButton />
                  )}
                </>
              ) : null}
            </div>

            <div></div>
          </div>
        </div>
        <AddAgendaModal
          IsAddAgendaModal={isAddAgendaModal}
          setIsAddAgendaModal={setIsAddAgendaModal}
          addAgenda={onAddAgenda}
          totalAgenda={agendaData?.length}
          agendaData={agendaData}
          fromEditMeeting={true}
          goToTop={goToTop}
          deleteAgenda={onDeleteAgenda}
          agendaDetails={meetingData?.singleMeetingDetails?.agendasDetail}
        />

        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this Agenda ?</Modal.Body>
          <Modal.Footer>
            {isLoading ? (
              <SmallLoaderButton />
            ) : (
              <Button
                className="add-minutes Mom-btn"
                onClick={handleDeleteConfirm}
              >
                <p>Delete</p>
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </form>
      <div className="attendee-array-error-messages">
        {meetingData?.errorMessage && (
          <div className="attendee-array-error-messages">
            <ul className="error-list error-message">
              {(Array.isArray(meetingData.errorMessage)
                ? meetingData.errorMessage
                : [meetingData.errorMessage]
              ).map((error, index) => (
                <li key={index} className="error-item">
                  {error}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default AddAgendas;
